import { StyleSheet } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import { BMPrimitives as tokenPrimitives, BMAnimation } from './bmTokens';
const { BMColor, BMOpacity: BMOpacityRaw, ...rest } = tokenPrimitives;
const BMFontSize = {
    '48p': 48,
    '30p': 30,
    '26p': 26,
    '24p': 24,
    '20p': 20,
    '18p': 18,
    '16p': 16,
    '15p': 15,
    '14p': 14,
    '12p': 12,
    '10p': 10,
};
const BMLineHeight = {
    '56p': 56,
    '36p': 36,
    '32p': 32,
    '28p': 28,
    '24p': 24,
    '20p': 20,
    '16p': 16,
    '12p': 12,
};
const fontWeight = {
    extraBold: '900',
    bold: '700',
    semiBold: '600',
    medium: '500',
    regular: '400',
};
const fontFamily = DRNUtil.isWeb() ? 'Godwit, NotoSansJP, System' : 'Godwit';
const BMTypography = {
    titleHero: {
        fontSize: BMFontSize['48p'],
        lineHeight: BMLineHeight['56p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    titleHuge: {
        fontSize: BMFontSize['30p'],
        lineHeight: BMLineHeight['36p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    titleLarge: {
        fontSize: BMFontSize['26p'],
        lineHeight: BMLineHeight['32p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    titleNormal: {
        fontSize: BMFontSize['20p'],
        lineHeight: BMLineHeight['24p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    titleSmall: {
        fontSize: BMFontSize['16p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    uiHuge: {
        fontSize: BMFontSize['16p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    uiHugeLi: {
        fontSize: BMFontSize['16p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.medium,
    },
    uiHugeEm: {
        fontSize: BMFontSize['16p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.extraBold,
    },
    uiLarge: {
        fontSize: BMFontSize['14p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    uiLargeLi: {
        fontSize: BMFontSize['14p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.medium,
    },
    uiLargeEm: {
        fontSize: BMFontSize['14p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.extraBold,
    },
    uiNormal: {
        fontSize: BMFontSize['12p'],
        lineHeight: BMLineHeight['16p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    uiNormalLi: {
        fontSize: BMFontSize['12p'],
        lineHeight: BMLineHeight['16p'],
        fontFamily,
        fontWeight: fontWeight.medium,
    },
    uiNormalEm: {
        fontSize: BMFontSize['12p'],
        lineHeight: BMLineHeight['16p'],
        fontFamily,
        fontWeight: fontWeight.extraBold,
    },
    uiSmall: {
        fontSize: BMFontSize['10p'],
        lineHeight: BMLineHeight['12p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    uiSmallLi: {
        fontSize: BMFontSize['10p'],
        lineHeight: BMLineHeight['12p'],
        fontFamily,
        fontWeight: fontWeight.medium,
    },
    uiSmallEm: {
        fontSize: BMFontSize['10p'],
        lineHeight: BMLineHeight['12p'],
        fontFamily,
        fontWeight: fontWeight.extraBold,
    },
    paragraphHuge: {
        fontSize: BMFontSize['24p'],
        lineHeight: BMLineHeight['36p'],
        fontFamily,
        fontWeight: fontWeight.regular,
    },
    paragraphHugeEm: {
        fontSize: BMFontSize['24p'],
        lineHeight: BMLineHeight['36p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    paragraphLarge: {
        fontSize: BMFontSize['18p'],
        lineHeight: BMLineHeight['28p'],
        fontFamily,
        fontWeight: fontWeight.regular,
    },
    paragraphLargeEm: {
        fontSize: BMFontSize['18p'],
        lineHeight: BMLineHeight['28p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    paragraphNormal: {
        fontSize: BMFontSize['15p'],
        lineHeight: BMLineHeight['24p'],
        fontFamily,
        fontWeight: fontWeight.regular,
    },
    paragraphNormalEm: {
        fontSize: BMFontSize['15p'],
        lineHeight: BMLineHeight['24p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    paragraphSmall: {
        fontSize: BMFontSize['12p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.regular,
    },
    paragraphSmallEm: {
        fontSize: BMFontSize['12p'],
        lineHeight: BMLineHeight['20p'],
        fontFamily,
        fontWeight: fontWeight.semiBold,
    },
    // Misc
    fontFamily,
    weightRegular: { fontFamily, fontWeight: fontWeight.regular },
    weightSemiBold: { fontFamily, fontWeight: fontWeight.semiBold },
    weightBold: { fontFamily, fontWeight: fontWeight.bold },
    fontSize: BMFontSize,
    lineHeight: BMLineHeight,
};
const BMBorder = {
    width: {
        thin: DRNUtil.isWeb() ? StyleSheet.hairlineWidth : 0.5,
        thick: 1,
        bold: 2,
    },
    radius: {
        default: 6,
        rounded: 9999,
    },
};
const BMOpacity = Object.entries(BMOpacityRaw).reduce((agg, [key, value]) => {
    return {
        ...agg,
        [key]: 0.01 * value,
    };
}, BMOpacityRaw);
const BMPrimitives = {
    ...rest,
    BMFontSize,
    BMBorder,
    BMTypography,
    BMAnimation,
    BMOpacity,
};
export { BMPrimitives };
